// extracted by mini-css-extract-plugin
export default {"contactLink":"ContactLink_contactLink__7l9xC"};